/* tslint:disable */
/* eslint-disable */
export enum WorkProjectAnalysisSourceEnum {
  CalculationItems = 'calculationItems',
  ProjectCosts = 'projectCosts'
}
